/**
 * Product History Log
 */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectLoading, makeSelectOrder } from '../orders/selectors';
import { makeSelectBundle } from '../bundles/selectors';
import { clearOrderAction, getOrderWithIdAction } from '../orders/actions';
import { clearBundleAction, getBundleWithIdAction } from '../bundles/actions';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Grid,
  Button,
  IconButton,
  InputBase,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiArrowRight,
  mdiCounter,
  mdiWarehouse,
  mdiMagnify,
  mdiAccountOutline,
  mdiMapMarkerOutline,
  mdiStateMachine,
  mdiCalendar,
  mdiClose,
  mdiTruckDeliveryOutline,
  mdiPrinter,
} from '@mdi/js';

// Type
import { SelectorProps, Props } from './interface';

// components
import { useForm } from 'react-hook-form';
import handleNotfication from '../../utils/handleNotification';
import { OrderTransportationType, translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import theme from '../../theme';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import handleError from '../../utils/handleError';
import List from './list';
import Modal from '../../components/Modal';
import { Response3PL } from './response3Pl';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    contentBox: {
      padding: theme.spacing(2),
      fontSize: '14px',
      fontWeight: 500,
    },
    contentlabel: {
      color: theme.palette.gray.light,
      marginRight: '10px',
      fontWeight: 400,
    },
    titleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.secondary.contrastText,
      padding: theme.spacing(2),
      borderRadius: '4px 4px 0 0',
    },
    paperHistory: {
      '@media (min-width: 768px)': {
        width: '40%',
      },
    },
    missingOppositeContent: {
      '&::before': {
        flex: 'none',
      },
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    contentLabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      '& .MuiFormGroup-row': {
        justifyContent: 'space-around',
      },
    },
  })
);

const myHeaders = new Headers();
const apiKey = localStorage.getItem('token');
myHeaders.append('Accept', 'application/octet-stream');
myHeaders.append('Authorization', `Bearer ${apiKey}`);
myHeaders.append('Sec-Fetch-Site', `cross-site`);
myHeaders.append('Sec-Fetch-Mode', `cors`);
myHeaders.append('Content-Type', 'application/json');

const fetchTapinString = async (selectedTapins) => {
  try {
    const delayTime = 1000;
    const response = await ordersRepository.getOrderTapin({ payload: { ids: selectedTapins } })
    const newWindow = window.open('about:blank', '_blank');
    newWindow?.document.open();
    newWindow?.document.write(response.data);
    setTimeout(() => newWindow?.print() , delayTime );
  } catch (err) {
    handleError(err)
  }
};


export function OrganizeBundles({
  getOrderDispatch,
  order,
  getBundleWithIdDispatch,
  bundle,
  clearBundleDispatch,
  clearOrderDispatch,
}: Props) {
  const classes = useStyles();
  const { handleSubmit, register } = useForm<Record<string, string>>();
  const [orderFilter, setOrderFilter] = useState('');//16442
  const [changeTransportationType, setChangeTransportationType] = useState(
    false as boolean
  );
  const [transportationValue, setTransportationValue] =
    useState<OrderTransportationType>('');
  const [result3PLs, setResult3PLs] = useState([]);
  const [openRequestConfirmation, setOpenRequestConfirmation] = useState(
    false as boolean
  );
  const [request3PLLoading, setRequest3PLLoading] = useState(false as boolean);
  const [openResponse3PL, setOpenResponse3PL] = useState(false as boolean);
  const onSubmit = (value: Record<string, any>) => {
    getOrder(value);
  };
  const [openAlopeykRequest, setOpenAlopeykRequest] = useState(
    false as boolean
  );
  const [orderResults3PL, setOrderResults3PL] = useState([
    {
      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
    {
      id: 1234,
      status: 'FAILED',
      message: 'بارگذاری ناموفق',
    },
    {
      id: 1234,
      status: 'SUCCESS',
      message: 'بارگذاری موفق',
    },
  ]);

  const getOrder = (value: Record<string, any>) => {
    getOrderDispatch(value);
    setOrderFilter('');
  };
  useEffect(() => {
    if ('bundleId' in order) {
      if (!order.bundleId) {
        handleNotfication('برای سفارش انتخابی مرسوله ای ثبت نشده است', 'warn');
      }
    }
    if (order?.bundleId) {
      getBundleWithIdDispatch({ id: order.bundleId });
    }
  }, [order]);

  useEffect(() => {
    get3PLs();
    return () => {
      if (bundle?.id) {
        clearBundleDispatch();
      }
      if (order?.id) {
        clearOrderAction();
      }
    };
  }, []);

  const handleCloseChangeTransportationType = () => {
    setChangeTransportationType(false);
  };

  const handleChangeTransportationValue = (e: any) => {
    setTransportationValue(e.target.value);
  };

  const get3PLs = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.get3PLs({
        payload,
      });
      setResult3PLs(response.data);
      callback && callback();
    } catch (error) {
      handleError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const handleCloseRequestConfirmation = () => {
    setOpenRequestConfirmation(false);
  };

  const handleSetOrders3PL = () => {
    setOrders3PL({
      body: { orderIds: [order?.id], tplCode: transportationValue },
    });
    if (transportationValue !== 'ALOPEYK') {
      setOpenResponse3PL(true);
    }
  };

  const setOrders3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const { response, callback } = await ordersRepository.setOrders3PL({
        payload,
      });
      setOrderResults3PL(response.data);
      setOpenRequestConfirmation(false);
      setChangeTransportationType(false);
      handleNotfication('نوع ارسال سفارش با موفقیت ثبت شد', 'success');
    } catch (error) {
      handleError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };

  const modalCloseHandler = () => {
    setOpenResponse3PL(false);
    setChangeTransportationType(false);
    setOpenRequestConfirmation(false);
  };

  return (
    <div className={classes.root}>
      <Grid container justify={'space-between'} spacing={5}>
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              سید بندی سفارش‌ها
            </Typography>
          </div>

          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                className={classes.input}
                name="id"
                autoFocus
                onChange={e => {
                  setOrderFilter(e.target.value);
                }}
                value={orderFilter}
                placeholder="شناسه سفارش"
                inputRef={register({ required: true })}
              />
            </form>
          </div>
        </Grid>
      </Grid>
      <Grid container justify="flex-end">
        <Button
          onClick={() => setChangeTransportationType(true)}
          variant="contained"
          color="primary"
          size="large"
          disabled={!order?.id}
        >
          ثبت در 3pl
        </Button>
        <IconButton
          onClick={() => {
            if (order?.id) {
              const win = window.open(
                `/3pl-print-labels?id=${order.id}`,
                '_blank'
              )!;
            }
          }
          }
          style={{
            border: '2px solid ',
            marginLeft: '5px',
            borderRadius: '5px',
          }}
        >
          <Icon path={mdiPrinter} size={1} color={'primary'} />
        </IconButton>

        <IconButton
          onClick={() => {
            if (order?.id) {
              fetchTapinString(order.id);
            }
          }}
          style={{
            border: '2px solid ',
            marginLeft: '5px',
            borderRadius: '5px',
          }}
        >
          <Icon path={mdiPrinter} size={1} color={'secondary'} />
          <Typography variant="subtitle1">تاپین</Typography>
        </IconButton>
      </Grid>
      <Paper elevation={3} className={classes.paper} variant="elevation" square>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiKeyOutline} size={1} className={classes.icon} />
                {`شناسه سفارش:  `}
              </span>

              <span>{order?.id}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiAccountOutline}
                  size={1}
                  className={classes.icon}
                />
                {'نام سفارش‌دهنده:  '}
              </span>

              <span>{order?.customerName}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                {`نام شرکت:  `}
              </span>
              <span>{order?.partnerName}</span>
            </div>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon path={mdiCounter} size={1} className={classes.icon} />
                {`نوع ارسال:  `}
              </span>
              <span>{translate(order?.deliveryType)}</span>
            </div>
          </Grid>

          <Grid item xs={12} sm={12}>
            <div className={classes.item}>
              <span className={classes.label}>
                <Icon
                  path={mdiMapMarkerOutline}
                  size={1}
                  className={classes.icon}
                />
                {`ادرس سفارش دهنده:  `}
              </span>
              <span>{order?.customerAddress}</span>
            </div>
          </Grid>
        </Grid>
      </Paper>
      {bundle?.id && (
        <Paper
          elevation={3}
          className={classes.paper}
          variant="elevation"
          square
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiKeyOutline}
                    size={1}
                    className={classes.icon}
                  />
                  {`شناسه مرسوله:  `}
                </span>

                <span>{bundle?.id}</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiAccountOutline}
                    size={1}
                    className={classes.icon}
                  />
                  {'نام راننده:  '}
                </span>

                <span>{bundle?.driverName}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiWarehouse} size={1} className={classes.icon} />
                  {`تاریخ تحویل:  `}
                </span>
                <span>
                  {bundle?.deliveryDate &&
                    `${jMoment(bundle?.deliveryDate, 'YYYY/MM/DD')
                      .locale('fa')
                      .format('jYYYY/jMM/jDD')}`}
                </span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCalendar} size={1} className={classes.icon} />
                  {`زمان تحویل:  `}
                </span>
                <span>
                  {bundle?.deliveryStartTime &&
                    jMoment(bundle?.deliveryStartTime, 'hh:mm:ss')
                      .locale('fa')
                      .format('HH:mm')}
                  {' - '}
                  {bundle?.deliveryEndTime &&
                    jMoment(bundle?.deliveryEndTime, 'hh:mm:ss')
                      .locale('fa')
                      .format('HH:mm')}
                </span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiMapMarkerOutline}
                    size={1}
                    className={classes.icon}
                  />
                  {`مرکز/انبار:  `}
                </span>
                <span>{bundle?.sourceName}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={12}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon
                    path={mdiStateMachine}
                    size={1}
                    className={classes.icon}
                  />
                  {`وضعیت مرسوله:  `}
                </span>
                <span>{translate(bundle?.status, 'bundle')}</span>
              </div>
            </Grid>
          </Grid>
        </Paper>
      )}
      <Grid container>
        <Grid item xs={12}>
          {order?.items?.length > 0 && (
            <List
              loading={false}
              data={order?.items}
            // selectedStatus={selectedStatus}
            // handleSelectedStatus={setSelectedStatus}
            // handleSelect={(id: number, status: string) => {
            //   selectItem(id, status);
            //   setId(id);
            // }}
            // selectedItems={selected}
            // selectAll={handleSelectAllClick}
            // head={head}
            // filterVal={filtersValues}
            // onFilterValue={(filtervalues: any) => {
            //   setFiltersValues({
            //     ...removeEmptyValueObject(filtervalues),
            //     ...filtersValues,
            //     page: 0,
            //     size: 10,
            //   });
            // }}
            // removeFilterHandler={removeFilterHandler}
            // filterLabelTranslator={filterTranslator}
            />
          )}
        </Grid>
      </Grid>
      <Dialog
        open={changeTransportationType}
        fullWidth
        onClose={handleCloseChangeTransportationType}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseChangeTransportationType}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.orange.main}
            />
          </div>

          <div className={classes.cancelTitle}>
            لطفا سرویس مورد نظر خود را انتخاب کنید
          </div>

          <div className={classes.typeSection}>
            <RadioGroup
              row
              aria-label="gender"
              name="gender1"
              value={transportationValue}
              onChange={handleChangeTransportationValue}
            >
              {result3PLs.map((tpl: any) => {
                return (
                  <FormControlLabel
                    value={tpl.code}
                    control={<Radio />}
                    label={
                      <img
                        style={{ width: '50px', objectFit: 'contain' }}
                        src={
                          tpl.code === 'LINK_EXPRESS'
                            ? '/link-express.png'
                            : tpl.code === 'TAROFF'
                              ? '/taarof.png'
                              : tpl.code === 'CHAPAR'
                                ? '/chapar.png'
                                : tpl.code === 'SPEED'
                                  ? '/speed.jpg'
                                  : tpl.code === 'PETROEX'
                                    ? '/Petroex.jpg'
                                    : tpl.code === 'PISHRO_POST'
                                      ? '/pishro-post.jpg'
                                      : tpl.code === 'TAPIN_POST'
                                        ? '/TAPIN_POST.svg'
                                        : tpl.code === 'DTSXP'
                                          ? '/DTSXP.png'
                                          :tpl.code === 'NEDEX'
                                          ? '/nedex.png'
                                          :tpl.code === 'TAPIN_KETAB'
                                          ?'TAPIN_KETAB.svg'
                                            : '/alopeyk.png'
                        }
                        alt={tpl.name}
                      />
                    }
                  />
                );
              })}
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseChangeTransportationType}
                variant="outlined"
                size="large"
              >
                {`انصراف`}
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={() => setOpenRequestConfirmation(true)}
                variant="contained"
                color="primary"
                size="large"
                disabled={!transportationValue}
              >
                {`تایید سرویس`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Modal
        maxWidth="lg"
        fullScreen
        onClose={modalCloseHandler}
        open={openResponse3PL}
        title={
          <div>
            <h3 style={{ padding: '0 20px' }}>
              {'ارسال درخواست به '}
              <strong>{translate(transportationValue, 'TPL')}</strong>
            </h3>
          </div>
        }
        content={<Response3PL data={orderResults3PL} />}
      />
      {/* <Modal
        maxWidth="lg"
        fullScreen
        onClose={() => setOpenAlopeykRequest(false)}
        open={openAlopeykRequest}
        title={
          <div>
            <h3
              style={{
                display: 'flex',
                marginBottom: 0,
                alignItems: 'center',
              }}
            >
              {`ارسال درخواست سفارش 
                   ${id} 
                     به `}
              <strong>{translate(transportationValue, 'TPL')}</strong>
              <img
                style={{
                  width: '60px',
                  objectFit: 'contain',
                  margin: '0 20px',
                }}
                src={'/alopeyk.png'}
                alt={'alopeyk'}
              />
            </h3>
          </div>
        }
        content={
          <AlopeykRequest orderId={orderResults3PL[0]?.id} id={orderResults3PL[0]?.id} />
        }
      /> */}
      <Dialog
        open={openRequestConfirmation}
        fullWidth
        onClose={handleCloseRequestConfirmation}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseRequestConfirmation}
            >
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.editIcon}>
            <Icon
              path={mdiTruckDeliveryOutline}
              size={4}
              color={theme.palette.orange.main}
            />
          </div>

          <div style={{ margin: '50px 0' }} className={classes.cancelTitle}>
            آیا از ارسال درخواست به
            <strong> {translate(transportationValue, 'TPL')} </strong>
            مطمئن هستید ؟
          </div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseRequestConfirmation}
                variant="outlined"
                size="large"
              >
                {`انصراف`}
              </Button>
            </Grid>
            <Grid item xs={8}>
              <Button
                fullWidth
                onClick={() => handleSetOrders3PL()}
                variant="contained"
                color="primary"
                size="large"
                disabled={request3PLLoading}
              >
                {`ارسال درخواست`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  order: makeSelectOrder(),
  bundle: makeSelectBundle(),
  loading: makeSelectLoading(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getOrderDispatch: (payload: any) => dispatch(getOrderWithIdAction(payload)),
    getBundleWithIdDispatch: (payload: any) =>
      dispatch(getBundleWithIdAction(payload)),
    clearBundleDispatch: () => dispatch(clearBundleAction()),
    clearOrderDispatch: () => dispatch(clearOrderAction()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
// @ts-ignore
export default compose(withConnect)(OrganizeBundles);
